import { instance, errorService } from '@/services/api'
import { masterAPIs } from '@/services/authConstantsV1'
import NotFound from '@/components/StaticComponent/404'
import _ from 'lodash'
import { calculateGridHeight } from '@/services/calculate'

export default {
  name: 'releaseNotes',
  components: {
    'not-found': NotFound,
  },

  data: function() {
    return {
      types: [],
      logs: [],
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
        'font-size': '2.5rem !important',
      },
      bodyStyle: {
        height: '52em',
        overflow: 'scroll',
        overflowX: 'hidden',
      },
      loading: false,
    }
  },
  created() {
    this.getLogs()
  },
  methods: {
    // Get Application Settings
    getLogs() {
      this.loading = true
      instance
        .get(masterAPIs.releaseLog.get)
        .then(response => {
          this.loading = false
          _.get(response.data, 'result.changeLogs', []).forEach(element => {
            element.changes = _.sortBy(element.changes, ['logTypeId'], ['asc'])
          })
          this.types = _.get(response.data, 'result.logTypes', [])
          this.logs = _.get(response.data, 'result.changeLogs', [])

          this.bodyStyle.height = calculateGridHeight('release-notes', true)
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },
  },
}
